import React from 'react';
import styled from 'styled-components';
import { coreapi } from '../../api';

import { useAuthToken } from '../../hooks';
import { TermsAndConditions } from '../../components/HellosignModal/Terms/TermsAndConditions';
import { Button, Modal } from '../../components';

const StyledModal = styled(Modal)`
  padding: 2rem;

  & > .content {
    max-height: 40rem;
    overflow-y: scroll;
    margin-bottom: 2rem;
  }
`;

export const useTocHelper = () => {
  const { authToken } = useAuthToken();
  const registerAcceptance = () =>
    coreapi.put(authToken!, '/team/registration/autoverify/accept');
  return { registerAcceptance };
};

export const TermsAndConditionsModal = ({ showToc = false, setShowToc }) => {
  return (
    <StyledModal
      isOpen={showToc}
      isClosable={true}
      onClose={() => {
        setShowToc(false);
      }}
      width={'70rem'}
      data-testid="toc-modal"
    >
      <div className="content">
        <TermsAndConditions />
      </div>
      <Button motif={'accent'} onClick={() => setShowToc(false)}>
        Close
      </Button>
    </StyledModal>
  );
};
